import EventEmitter from 'src/helpers/EventEmitter'
import store from 'src/store'

import ImageService from '@/services/ImageService' 
const THREE = require('three')

import vert from '@/shaders/question/text.vert' 
import frag from '@/shaders/question/text.frag'
 
  
class Bg extends THREE.Group { 

  constructor(config) {

    super();
  
    Object.assign(this, EventEmitter)  
   
    this.setup(); 
    this.resize() 
  }

  setup(){
    
    this.active = true;
    let texture = this.createTexture(require('@/assets/img/question/result/distortion/mellow.jpg'));
    texture.wrapS = THREE.MirroredRepeatWrapping;
    texture.wrapT = THREE.MirroredRepeatWrapping;
    this.distortion_texture = texture;
    this.tapHoldTexture = this.createTexture(require('@/assets/img/taphold.png'));
    this.material = new THREE.ShaderMaterial({
      vertexShader : vert,
      fragmentShader : frag,
      transparent: true,
 
      uniforms : { 
        tDistortion: {
          value: this.distortion_texture,
          type: "t"
        },
        tDrawing: {
          value: this.tapHoldTexture,
          type: "t"
        }, 
        time :{
          type : "f",
          value : 0
        }, 
        alpha :{
          type : "f",
          value : 1.0
        }, 
        amt :{
          type : "f",
          value : 1.0
        }, 
        yOffset :{
          type : "f",
          value : 0.0
        }
      }
    });
    this.geometry = new THREE.PlaneBufferGeometry(1,1);
    this.mesh = new THREE.Mesh(
      this.geometry, 
      this.material
    );

    this.mesh.position.z = 10;  
    this.add(this.mesh)
    
    this.resize();
  } 

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img); 
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;  
    // texture.magFilter = THREE.NearestFilter;
    // texture.minFilter = THREE.NearestFilter;
    // texture.anisotropy = 0; 
    texture.needsUpdate = true;
    return texture;
  }
   
  tick(tap_hold_ratio) {
    // let ratio = window.Power2.easeInOut.getRatio( tap_hold_ratio) ;
    // this.scale.x = this.scale.y =  1 - (ratio * 0.15);
    // this.position.y = this.tweenObj.yOffset + Math.sin(this.count) * 20; 
    // this.count += 0.015;

    if(this.active){ 
      this.material.uniforms.time.value -= 0.001; 
      this.material.uniforms.alpha.value = 1 - tap_hold_ratio; 
      this.material.uniforms.amt.value = 1.0 - (0.99 * tap_hold_ratio); 
    }
 
  }

  idle() {
 
  }

  tapholdProgress() {

    // TweenMax.to(this.material.uniforms.alpha, 2, {
    //   value: 0,
    //   delay: 0.2,
    //   ease: 'Expo.easeInOut'
    // })

    // TweenMax.to(this.material.uniforms.amt, 2, {
    //   value: 0.01,
    //   ease: 'Power3.easeOut'
    // }),
    // TweenMax.to(this.material.uniforms.yOffset, 2, {
    //   value: 0.2,
    //   ease: 'Power3.easeOut'
    // })
  }
  
  tapholdRecord() {
 
    if(!this.active){
      return
    }

    TweenMax.to(this.material.uniforms.alpha, 0.5, {
      value: 0,
      onComplete: this.destroy
    });
  }

  destroy = () => {
    this.distortion_texture.dispose()
    this.tapHoldTexture.dispose()
    this.material.dispose()
    this.material = null
    this.active = false;
  }

  tapholdRelease() {}
    
  processing() {  }
    
  complete(val) { 

    switch(val) {
      case 0:
        this.furious();
        break;
      case 1:
        this.sad();
        break;
      case 2:
        this.angry();
        break;
      case 3:
        this.agitated();
        break;
      case 4:
        this.confused();
        break;
      case 5:
        this.mildlyamused();
        break;
      case 6:
        this.amused();
        break;
      case 7:
        this.happy();
        break;
      case 8:
        this.ecstatic();
        break;
      case 9:
        this.error();
        break;
    }
    
  }

  result(val){ }

  furious(){  }

  sad(){ }

  angry(){ }

  agitated(){  }

  confused(){ }

  mildlyamused(){  }
  
  amused(){   }

  happy(){   }

  ecstatic(){  }
  
  error(){  }
  
  updateRoute(val) {

     if(val.name === 'question'){
 
    } else if(val.name === 'result') {
 
    }
  }

  updateState(val){}
 
  resize() {
    this.mesh.scale.x = window.innerWidth;
    this.mesh.scale.y = window.innerHeight * 1.2;
    this.mesh.position.y = 50;
  }
 
 
}

export default Bg